import { useEffect, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";

export const CameraControls = () => {
  const {
    camera,
    gl: { domElement },
  } = useThree();

  const controls = useRef();
  useEffect(() => {
    if (controls.current) {
      controls.current.rotateSpeed = 0.3;
      controls.current.zoomSpeed = 0.1;
      controls.current.minDistance = 0;
      controls.current.maxDistance = 30;
      controls.current.minPolarAngle = 0; // radians
      controls.current.maxPolarAngle = Math.PI; // radians
      controls.current.enableDamping = true;
      controls.current.dampingFactor = 0.05;
    }
  }, [controls]);
  useFrame(() => controls?.current.update());
  return (
    <OrbitControls
      ref={controls}
      target={[0, 0.073, 0]}
      args={[camera, domElement]}
    />
  );
};
